import { render, staticRenderFns } from "./TemplateSummaryTable.vue?vue&type=template&id=673010e9&scoped=true&"
import script from "./TemplateSummaryTable.vue?vue&type=script&lang=ts&"
export * from "./TemplateSummaryTable.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateSummaryTable.vue?vue&type=style&index=0&id=673010e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673010e9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VIcon,VSimpleTable})
